.toaster {
  position: fixed;
  bottom: calc(max(var(--space-6), calc(env(safe-area-inset-bottom) + var(--space-4))) + var(--rodape-fixo, 0px));
  left: 50%;
  z-index: 50;
  transform: translateX(-50%);
  pointer-events: none;
}

.toaster > * {
  pointer-events: auto;
  animation: rise 160ms ease-out both;
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}
